<div class="loan-card-wrapper" *ngIf="!showDetails && Loan && (Loan.length > 0)" [class.past]="viewType === 'Past'">
    <div *ngFor="let loan of Loan" class="card loan-card">
        <div class="product-column" (click)="showLoanDetails(loan)">
            <div class="merchant-icon">
                <img
                    [src]="logoBaseUrl+'/logo-icons/'+(loan.MerchantName | lowercase)+'-logo-icon.png'"
                    [alt]="loan.MerchantName | lowercase"
                />
            </div>
            <div class="product-details">
                <div class="product-name" *ngFor="let product of Loan.ProductNames" [textContent]="product"></div>
                <div class="merchant-name" [textContent]="loan.MerchantName"></div>
            </div>
            <div [class]="'emi-status ' + loan.Status" [textContent]="showStatus(loan)"></div>
            <div class="right-icon">
                <i class="right"></i>
            </div>
        </div>
        <div class="loan-detail-wrapper">
            <div class="loan-detail-section">
                <div class="emi-amount-section">
                    <div class="title" [textContent]="(viewType === 'Active') ? 'EMI amount' : 'Loan Amount'"></div>
                    <div class="emi-amount" [textContent]="((viewType === 'Active') ? (getLoanAmount(loan) | RupeeCurrencyPipe) : (loan.LoanAmount | RupeeCurrencyPipe))"></div>
                </div>
                <div class="emi-due-date">
                    <div class="title" [textContent]="(viewType === 'Active') ? ' Due Date' : 'Amount Paid'">
                    </div>
                    <div *ngIf="viewType === 'Past'" [textContent]="(loan.LoanAmount | RupeeCurrencyPipe)"></div>
                    <div *ngIf="viewType === 'Active'">
                        <p *ngIf="loan.Status !=='MerchantRefund' && loan.Status !=='RefundInitiated'" [textContent]="(loan.Repayments ? (getnextDueDate(loan.Repayments)| date:'dd MMM yyyy'): '--' )"></p>
                        <p *ngIf="loan.Status =='MerchantRefund' || loan.Status =='RefundInitiated'">-- </p>
                    </div>
                </div>
                <div class="emi-overdue">
                    <div class="title" [textContent]="(viewType === 'Active') ? 'EMI paid' : 'EMI Tenure'"></div>
                    <div [textContent]="(viewType === 'Active') ? (getPaidEmis(loan.Repayments) + '&nbsp;' + 'of' + '&nbsp;' + loan.NumbersOfMonth) : (loan.NumbersOfMonth)"></div>
                </div>
            </div>
            <div class="pay-now-cta pay-now-btn-wrapper" *ngIf="((viewType === 'Active') && (loan.Status !== 'Approved'))">
                <button
                    class="pay-now-button btn btn-flat"
                    [class.btn-wiggle]="!quickPayClicked"
                    id="_quickPay"
                    (click)="triggerSMS()"
                    angulartics2On="click"
                    angularticsEvent="quick-pay"
                    angularticsCategory="quick-pay"
                >
                    PAY NOW
                </button>
            </div>
        </div>
    </div>
</div>
<zest-loans-detail *ngIf="showDetails" (hideLoanDetails)="onValueUpdated($event)" [selectedLoan]="selectedLoan" [viewType]="viewType" [emiDateStatus]="{'arrearTextBelowQuickPay': arrearTextBelowQuickPay, 'pendingTextBelowQuickPay': pendingTextBelowQuickPay}" (triggerSMSfromDetails)="triggerSMS()"></zest-loans-detail>

<div class="no-loan-section card" *ngIf="Loan && (Loan.length === 0)">
    <div class="banner-image">
    <img [src]="(this.viewType === 'Active') ? '../../../assets/images/Loan.svg' : '../../../assets/images/Pastloan.svg'" />
    </div>
    <div class="title">NO <span [textContent]="viewType | uppercase"></span> LOANS</div>
    <div class="desc">You don't have any <span [textContent]="viewType"></span> loans</div>
</div>
